import { render, staticRenderFns } from "./sgsst-policies.vue?vue&type=template&id=0e031388&"
import script from "./sgsst-policies.vue?vue&type=script&lang=js&"
export * from "./sgsst-policies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports